<template>
  <div class="main-content-container container-fluid px-4">
    <div class="page-header row no-gutters py-4">
      <div class="col-8 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Vtex \ <span class="ActiveURL">Brand & Category Update</span></span>
        <!-- <h3 class="page-title">upload Syncc data</h3> -->
      </div>
    </div>
    <d-card class="card-small mb-4">
      <!-- Card Header -->
      <d-card-header class="border-bottom">
        <span style="font-size:20px; font-weight:500" class="m-0">Brand & Category Update</span>

        <!-- <router-link :to="{ name: 'user-setup'}">
          <button
            class="btn btn-md btn-primary"
            style="margin-left: 900px;background-color:white;margin-top:-40px;color:black;"
          >Dashboard</button>
          style="margin-left: 400px;background-color:white;margin-top:-30px;color:black;" 
        </router-link> -->

        <button
            class="btn btn-md btn-primary"
            style="float:right; background-color:white; color:black;"
          >
          <download-excel :data="ProductMasterUpload.DataModel.UIData.VtexProductTemplate"   name="VtexBrandAndCategory_Templates"><span style="marige-top:10px;" > Download Template </span>   </download-excel>  </button>


      </d-card-header>

      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-row>
            <d-col>
              <d-form id="pricing">
                <d-form-row>
                 
               
                  <d-col md="12" class="form-group row">
                    <label class="col-md-3 col-form-label">Select Template file *</label>
                    <div class="col-md-7" v-if="ProductMasterUpload.DataModel.UIData.UploadedDataCount == 0">   
                         <div class="button_group">
                          <a href="javascript:;" class="button_s my_file el-button button_s el-button--primary el-button--small" >
                          
                          <input type="file" id="avatar" @change="importExcel" name="avatar">
                          </a>
                          <!-- :disabled="(ProductMasterUpload.DataModel.UIData.ProductMasterList.length == 0)" -->
                          <d-button type="button" id="submit" title="Please Select the panel"  class="btn-accent" :disabled="(ProductMasterUpload.DataModel.UIData.ProductMasterList.length == 0)" @click="ProductMasterUploadData" style="margin-right:10px" >upload Data</d-button>
                                <d-button type="button" id="submit" class="btn-accent" @click="ClearFileData">Cancel</d-button>
                          </div>
                    </div>
                     <div class="col-md-7" v-if="ProductMasterUpload.DataModel.UIData.UploadedDataCount > 0">  
                         <div class="SuccessLabel">
                           <span class="material-icons"> done_all </span> {{ ProductMasterUpload.DataModel.UIData.LoadedFileName }} file data uploaded Successfully 
                         </div>
                    </div>
                  </d-col>

                 <d-col md="12" class="form-group row" v-if="ProductMasterUpload.DataModel.UIData.UploadStatus">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds from file</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{ProductMasterUpload.DataModel.Data.SynccentricScrapList}}</label>
                    </div>
                 </d-col>

                 <d-col md="12" class="form-group row" v-if="ProductMasterUpload.DataModel.UIData.UploadStatus">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds Rejected</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{ProductMasterUpload.DataModel.UIData.RejectedList.length}}</label>
                    </div>
                 </d-col>


                <d-col md="12" class="form-group row" v-if="ProductMasterUpload.DataModel.UIData.UploadStatus">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds Progressed</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{ProductMasterUpload.DataModel.UIData.Progressed}}</label>
                    </div>
                 </d-col>
                
                <d-col md="12" class="form-group row"  v-if="(ProductMasterUpload.DataModel.UIData.Progressed == ProductMasterUpload.DataModel.UIData.ProductMasterList.length) && ProductMasterUpload.DataModel.UIData.UploadStatus">
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7" v-if="(ProductMasterUpload.DataModel.UIData.RejectedList.length)">
                    <d-button type="button" class="btn-accent"  > 
                    <download-excel  :data="ProductMasterUpload.DataModel.UIData.RejectedList"   :name="ProductMasterUpload.DataModel.UIData.RejectedFileName"><span style="marige-top:10px;" > Download Reject List </span> </download-excel>
                    </d-button>
                    </div>

<div class style="text-align:center"  v-if="ProductMasterUpload.DataModel.UIData.UploadStatus">
                  <d-button type="button" id="submit" class="btn-accent" @click="ClearUsersetup">Cancel</d-button>
                </div>         

                  </d-col>

                <!-- <div class style="text-align:center"  v-if="ProductMasterUpload.DataModel.UIData.UploadStatus">
                  <d-button type="button" id="submit" class="btn-accent" @click="ClearUsersetup">Cancel</d-button>
                </div>          -->
 

                </d-form-row>

                <br />

              </d-form>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </d-card>
    <div v-if="ProductMasterUpload.PageLoad" class="load-container load1"><div class="loader">Loading...</div></div>
  </div>
</template>
<script>
import Utilities from "@/Utilities/Utilities";
import axios from "axios";
import xlsx from "xlsx";
import XLSX from 'xlsx';
import $ from 'jquery'

export default {
  name: 'ProductMasterUpload',
   data() {
    return {
      ProductMasterUpload: {
        PageType: "Master",
        PageLoad: false, 
        DataModel: {
          Data: {
             QueryString:null,
            ProductMaster:null,
            ProductMasterList:[],
            Token:null,
            Curd:null,
            CreatedBy:0
          },
          UIData: {
            mySteps:['Step 1', 'Step 2', 'Step 3'],
            currentStep:0,
            Template:[],
            minMaxList:[],
            Progressed:0,
            RejectedList:[],
            AvailablityTemplate:[],
            RejectedFileName:null,
            ProductMasterList:[],
            ProductMasterList1:[],
            ProductMasterList2:[],
            ProductMasterList3:[],
            ProductMasterList4:[],
            ProductMasterList5:[],
            ProductMasterList6:[],
            ProductMasterList7:[],
            ProductMasterList8:[],
            ProductMasterList9:[],
            ProductMasterList10:[],
            AvailablityList:[],
            AvailablityTemplateCount:0,
            TemplateIsAvailable :false,
            FileName:"Template",
            LoadedFileName:"",
            AvailabilityFileName:"Template",
            UploadedDataCount:0,
            VtexProductTemplate:[{
                ProductId:0,
                BrandId:0,
                CategoryId:0
            }]
          },
        },
        SessionInfo: {
          PageInfo: {
            userId: 0,
          },
        },
        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "",
            ErrorMessage: "",
          },
        ],

        Masters: {
          CountryMaster:[],
          PanelList:[
            {
              Name : "Amazon UAEDirect",
              Country:"UAEDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon India",
              Country:"India",
              Panel:"Amazon"
            },
            {
              Name : "Amazon IndiaDirect",
              Country:"IndiaDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Australia",
              Country:"Australia",
              Panel:"Amazon"
            },
            {
              Name : "Amazon UAE",
              Country:"UAE",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Mexico",
              Country:"Mexico",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Canada",
              Country:"Canada",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Brazil",
              Country:"Brazil",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Singapore",
              Country:"Singapore",
              Panel:"Amazon"
            },
            {
              Name : "Amazon KSA",
              Country:"KSA",
              Panel:"Amazon"
            },
            {
              Name : "Jokoka",
              Country:"UAE",
               Panel:"Jokoka"
            },
            {
              Name : "StoreUS",
              Country:"UAE",
               Panel:"StoreUS"
            },
            {
              Name : "Noon UAE",
              Country:"UAE",
              Panel:"Noon"
            },
            {
              Name : "Noon KSA",
              Country:"KSA",
              Panel:"Noon"
            }
          ]
        },
      },
    };
  },

  mounted(){
      this.ProductMasterUpload.SessionInfo.PageInfo.userId = sessionStorage.getItem("UserId");
       this.ProductMasterUpload.DataModel.Data.CreatedBy = sessionStorage.getItem("UserId");
      // this.ListAllFromCountry();
  },
  methods: {
ClearFileData(){
     this.ProductMasterUpload.DataModel.Data.FromCountry = null;
     this.ProductMasterUpload.DataModel.UIData.UploadedDataCount = 0;
     this.ClearUsersetup();
     document.getElementById("pricing").reset();
},

panelOnchange(){

            this.ProductMasterUpload.DataModel.UIData.Template=[];
            this.ProductMasterUpload.DataModel.UIData.TemplateIsAvailable = false;
},

ClearUsersetup(){
            this.ProductMasterUpload.DataModel.UIData.Template = [];
            this.ProductMasterUpload.DataModel.UIData.TemplateIsAvailable = false;
            this.ProductMasterUpload.DataModel.Data.SynccentricScrapList = 0;
            this.ProductMasterUpload.DataModel.UIData.UploadStatus = false;
            this.ProductMasterUpload.DataModel.UIData.ProductMasterList=[];
            // this.cleareList();
        this.ProductMasterUpload.DataModel.Data.PanelInfo ={
          Name : null,
              Country:null
        }
        this.ProductMasterUpload.DataModel.Data.FromCountry =null;
        this.ProductMasterUpload.DataModel.UIData.UploadedDataCount= 0;
         document.getElementById("pricing").reset();
      },

getQuery()
{
      let vm = this;
      vm.ProductMasterUpload.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.ProductMasterUpload.DataModel.Data.Token = Token;
      this.ProductMasterUpload.DataModel.Data.CRUD = "AmazonAEMasterUpload";
      var dataString = JSON.stringify(this.ProductMasterUpload.DataModel.Data);

      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.ProductMasterUpload.PageLoad = false;
            vm.ProductMasterUpload.DataModel.UIData.UploadedDataCount= response.data.Result;
            vm.UpDateProductMasterUploadsMaster();
          } else {

          }
        })
        .catch(function (response) {
          // console.log(response);
            vm.ProductMasterUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

},



UpDateProductMasterUploadsMaster()
{
      let vm = this;
      vm.ProductMasterUpload.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.ProductMasterUpload.DataModel.Data.Token = Token;
      this.ProductMasterUpload.DataModel.Data.CRUD = "AmazonAEMasterUpload";
      this.ProductMasterUpload.DataModel.Data.QueryString = "update AmazonProductMaster tgt  , ProductMasterUploadsMaster src SET tgt.Handling_Time =  src.ProductMasterUploads , tgt.price = src.Price WHERE src.sku = tgt.seller_sku";
      var dataString = JSON.stringify(this.ProductMasterUpload.DataModel.Data);
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.ProductMasterUpload.PageLoad = false;
            vm.ProductMasterUpload.DataModel.UIData.UploadedDataCount= response.data.Result;
            vm.ClearProductMasterUploadsMaster();
          } else {

          }
        })
        .catch(function (response) {
          // console.log(response);
            vm.ProductMasterUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

},

ClearProductMasterUploadsMaster()
{
      let vm = this;
      vm.ProductMasterUpload.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.ProductMasterUpload.DataModel.Data.Token = Token;
      this.ProductMasterUpload.DataModel.Data.CRUD = "AmazonAEMasterUpload";
      this.ProductMasterUpload.DataModel.Data.QueryString = "truncate TABLE ProductMasterUploadsMaster";
      var dataString = JSON.stringify(this.ProductMasterUpload.DataModel.Data);
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.ProductMasterUpload.PageLoad = false;
            vm.ProductMasterUpload.DataModel.UIData.UploadedDataCount= response.data.Result;
            vm.$toaster.success("Updated Successfully.");
          } else {

          }
        })
        .catch(function (response) {
          console.log(response);
            vm.ProductMasterUpload.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

},

    CreateProductMaster : async(dataString,mythis) => {
      var AxiosResponse= null;
      var reqtime=0;

    
        // return new Promise((resolve, reject) => {
            // Do something here... lets say, a http call using vue-resource
             setTimeout(() => {
                axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
                      .then(function (response) {
                        mythis.ProductMasterUpload.DataModel.UIData.Progressed = mythis.ProductMasterUpload.DataModel.UIData.ProductMasterList1.length;
                        if (response.data.ErrorInfo == null) {
                          mythis.ProductMasterUpload.PageLoad = false;
                          // console.log(response.data.Result);
                          response.data.Result.map(function(value,key){
                              // vm.$toaster.error("record Not saved.");
                            //  console.log(response.data.Result);
                              let failedProduct={
                                      ...value.SKUDetails,
                                      ...value.ProductMaster,
                              }
                              mythis.ProductMasterUpload.DataModel.UIData.RejectedList.push(Utilities.JsonCopy(failedProduct));
                              // resolve(response);
                          })
                          console.log(response.data.Result);  
                          mythis.ProductMasterUpload.DataModel.UIData.UploadedDataCount = 1;
                        } else {
                            console.log(response.data.ErrorInfo);
                            mythis.ProductMasterUpload.PageLoad = false;
                        }
                      })
                      .catch(function (response) {  
                        // reject(response);
                        console.log(response);  
                        mythis.ProductMasterUpload.PageLoad = false;
                        // vm.$swal.fire("Oops", "Something went worng", "error");
                      })
                  }, 2000);
                },

anAsyncFunction : async(item,mythis ) => {
  return mythis.CreateProductMaster(item,mythis)
},

getData : async (mythis) => {
    let vm = mythis;
      var Token = sessionStorage.getItem("Token");

      mythis.ProductMasterUpload.DataModel.Data.Token = Token;
      mythis.ProductMasterUpload.DataModel.Data.CRUD = "ProductMasterCreateList";
      mythis.ProductMasterUpload.DataModel.UIData.UploadStatus = false;
      mythis.ProductMasterUpload.DataModel.UIData.RejectedList=[];
      mythis.ProductMasterUpload.DataModel.UIData.Progressed = 0;
      mythis.ProductMasterUpload.DataModel.Data.ProductMasterList =mythis.ProductMasterUpload.DataModel.UIData.ProductMasterList1 
      
      // mythis.ProductMasterUpload.DataModel.UIData.ProductMasterList.map(function(value,key){
        
          // vm.ProductMasterUpload.DataModel.Data.ProductMaster = Utilities.JsonCopy(value);
          var dataString = JSON.stringify(vm.ProductMasterUpload.DataModel.Data);
          vm.ProductMasterUpload.PageLoad = true;
          vm.ProductMasterUpload.DataModel.UIData.UploadedDataCount = 0;
          vm.ProductMasterUpload.DataModel.UIData.RejectedFileName = "RejectedList" + " " + Date.now();
          vm.anAsyncFunction(dataString,vm)
 
},

AddProduct : async (mythis) => {  
   let vm = mythis;
      var Token = sessionStorage.getItem("Token");
      mythis.ProductMasterUpload.DataModel.Data.Token = Token;
      mythis.ProductMasterUpload.DataModel.Data.CRUD = "UpdateBrandCategory";
      mythis.ProductMasterUpload.DataModel.Data.CreatedBy = Number(mythis.ProductMasterUpload.SessionInfo.PageInfo.userId);
      mythis.ProductMasterUpload.DataModel.UIData.UploadStatus = false;
      mythis.ProductMasterUpload.DataModel.UIData.RejectedList=[];
      mythis.ProductMasterUpload.DataModel.UIData.Progressed = 0;
      for (var i = 0; i < mythis.ProductMasterUpload.DataModel.UIData.ProductMasterList.length; i++) {

          vm.ProductMasterUpload.DataModel.Data.ProductMaster = Utilities.JsonCopy(mythis.ProductMasterUpload.DataModel.UIData.ProductMasterList[i]);
          var dataString = JSON.stringify(vm.ProductMasterUpload.DataModel.Data);
          vm.ProductMasterUpload.PageLoad = true;
          vm.ProductMasterUpload.DataModel.UIData.UploadedDataCount = 0;
          vm.ProductMasterUpload.DataModel.UIData.RejectedFileName = "RejectedList" + " " + Date.now();
        try {
          let response = await axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString);
             if (response.data.ErrorInfo == null) {
               mythis.ProductMasterUpload.DataModel.UIData.Progressed+=1;
               mythis.ProductMasterUpload.PageLoad = false;
                mythis.ProductMasterUpload.DataModel.UIData.UploadedDataCount = 1;
          } else {
              console.log(response.data.ErrorInfo);
              mythis.ProductMasterUpload.PageLoad = false;
          }
        } catch (error) {
          console.log(error);
          mythis.ProductMasterUpload.PageLoad = false;
        }
       }
},
      


    
        ProductMasterUploadData(){
          $.when(
          // this.getData(this)
          this.AddProduct(this)
        ).then(console.log("success"), console.log("Failure"));

        this.ProductMasterUpload.DataModel.UIData.UploadStatus = true;
        this.$toaster.error("Task Comepeleted.");
      },

  // UploadedDataCount

    getHeader(sheet) {
      const XLSX = xlsx;
      const headers = [];
      const range = XLSX.utils.decode_range(sheet["!ref"]); // worksheet['!ref'] Is the valid range of the worksheet
      let C;
      /* Get cell value start in the first row */
      const R = range.s.r; //Line / / column C
      let i = 0;
      for (C = range.s.c; C <= range.e.c; ++C) {
        var cell =
          sheet[
            XLSX.utils.encode_cell({ c: C, r: R })
          ]; /* Get the cell value based on the address  find the cell in the first row */
        var hdr = "UNKNOWN" + C; // replace with your desired default
        // XLSX.utils.format_cell Generate cell text value
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        if(hdr.indexOf('UNKNOWN') > -1){
          if(!i) {
            hdr = '__EMPTY';
          }else {
            hdr = '__EMPTY_' + i;
          }
          i++;
        }
        headers.push(hdr);
      }
      return headers;
    },
    /**
     * Import table
     */
     importExcel(e) {

      const files = e.target.files;
      this.ProductMasterUpload.PageLoad = true;
      this.ProductMasterUpload.DataModel.UIData.LoadedFileName = files[0].name;
      if (!files.length) {
        return ;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.ProductMasterUpload.PageLoad = false;
        return alert("The upload format is incorrect. Please upload xls or xlsx format");
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          console.log(ev);
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the data of the first sheet
          const excellist = []; // Clear received data
          

          this.ProductMasterUpload.DataModel.Data.SynccentricScrapList = 0 ;
          this.ProductMasterUpload.DataModel.UIData.ProductMasterList = [];


          for (var i = 0; i < ws.length; i++) {

            var ProductInfo={
              ProductId:0,
              BrandId:0,
              CategoryId:0
            }

            if(ws[i].ProductId!=undefined)	
                ProductInfo.ProductId = ws[i].ProductId;
            else
                ProductInfo.ProductId = null;

            if(ws[i].BrandId!=undefined)
                  ProductInfo.BrandId = ws[i].BrandId;
            else
                  ProductInfo.BrandId = 0;

          if(ws[i].CategoryId!=undefined)
                  ProductInfo.CategoryId = ws[i].CategoryId;
            else
                  ProductInfo.CategoryId = 0;

            this.ProductMasterUpload.DataModel.UIData.ProductMasterList.push(Utilities.JsonCopy(ProductInfo));

        }

          console.log(this.ProductMasterUpload.DataModel.UIData.ProductMasterList);

          const a = workbook.Sheets[workbook.SheetNames[0]];
          const headers = this.getHeader(a);
          this.ProductMasterUpload.PageLoad = false;
        } catch (e) {
          console.log(e); 
            this.ProductMasterUpload.PageLoad = false;
          return alert("Read failure!");;
        }
      };
      fileReader.readAsBinaryString(files[0]);
      var input = document.getElementById("upload");
    },

 previewFiles(e) {
          console.log("test");
          var files = e.target.files, f = files[0];
          var reader = new FileReader();
          reader.onload = function(e) {
            var data = new Uint8Array(e.target.result);
            var workbook = XLSX.read(data, {type: 'array'});
            let sheetName = workbook.SheetNames[0]
            /* DO SOMETHING WITH workbook HERE */
            console.log(workbook);
            let worksheet = workbook.Sheets[sheetName];
            console.log(XLSX.utils.sheet_to_json(worksheet));
          };
          reader.readAsArrayBuffer(f);
       }
  }
}
</script>